import React from "react";
import { Wordmark } from "./Wordmark";
import { BRAND } from "../data/copy";

/**
 * Fixed nav. "mintikk.." left, "SHOP" pill right.
 * Uses mix-blend-mode:difference to stay legible over light and dark sections.
 */
export const Nav = ({ onShop }) => {
  return (
    <header className="mk-nav" data-testid="site-nav">
      <a href="#hero" className="mk-nav__brand" data-testid="nav-wordmark" aria-label="mintikk home">
        <Wordmark />
      </a>
      <button
        type="button"
        className="mk-nav__shop"
        data-testid="nav-shop-button"
        onClick={onShop}
      >
        {BRAND.shop}
      </button>
    </header>
  );
};

export default Nav;
